import { render, staticRenderFns } from "./SpecEditor.vue?vue&type=template&id=3758988c&scoped=true&"
import script from "./SpecEditor.vue?vue&type=script&lang=js&"
export * from "./SpecEditor.vue?vue&type=script&lang=js&"
import style0 from "./SpecEditor.vue?vue&type=style&index=0&id=3758988c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3758988c",
  null
  
)

export default component.exports